import { z } from 'zod';
import { v4PageOf } from '../__shared__/page.schemas.ts';
import { cropSchema } from '../crop/schemas.ts';

const uuid = z.string().uuid();
const dateTimeWithOffset = z.string().datetime({ offset: true });

export const seasonSchema = z.object({
  id: uuid,
  name: z.string(),
  start_date: dateTimeWithOffset,
  end_date: dateTimeWithOffset,
  crop: cropSchema
});

export const seasonFlatSchema = z.object({
  id: uuid,
  name: z.string(),
  start_date: dateTimeWithOffset,
  end_date: dateTimeWithOffset,
  crop_id: uuid,
  org_id: uuid,
  active: z.boolean(),
  deleted: z.boolean()
});

export const seasonCompanySchema = seasonFlatSchema.extend({
  created_at: dateTimeWithOffset,
  updated_at: dateTimeWithOffset,
  created_by_id: uuid,
  last_updated_by_id: uuid
});

export const allSeasonsResponseSchema = v4PageOf(seasonCompanySchema);

const seasonDeepVarietySchema = z.object({
  actualProductivity: z.number(),
  areaInHectares: z.number(),
  id: z.string(),
  variety: z.object({
    companyId: z.string(),
    deleted: z.boolean(),
    id: z.string(),
    lastPrice: z.number(),
    manufacturer: z.string(),
    name: z.string(),
    productType: z.string(),
    unitOfMeasure: z.string(),
    vendorId: z.string()
  })
});

const seasonPlanPhaseSchema = z.object({
  id: z.string(),
  name: z.string(),
  templatesIds: z.array(z.string())
});

const seasonPlanSchema = z.object({
  companyId: z.string(),
  id: z.string(),
  name: z.string(),
  phases: z.array(seasonPlanPhaseSchema)
});

export const seasonDeepSchema = z.object({
  id: z.string(),
  name: z.string(),
  startsAt: z.string(),
  endsAt: z.string(),
  actualProductivity: z.number(),
  areaTotalInHectares: z.number(),
  productivityForecast: z.number(),
  productivityLastSeason: z.number(),
  company: z.object({ id: z.string(), name: z.string() }),
  crop: z.object({ id: z.string(), name: z.string() }),
  properties: z.array(z.object({ id: z.string(), name: z.string() })),
  seasonPlans: z.array(seasonPlanSchema),
  seasonProperties: z.array(z.object({ id: z.string(), name: z.string() })),
  varieties: z.array(seasonDeepVarietySchema)
});

const seasonTreeAreaSchema = z.object({
  id: z.string(),
  area: z.object({ id: z.string(), name: z.string() })
});

const seasonTreePropertySchema = z.object({
  id: z.string(),
  property: z.object({ id: z.string(), name: z.string() }),
  seasonAreas: z.array(seasonTreeAreaSchema)
});

export const seasonTreeSchema = z.object({
  season: z.object({ id: z.string(), name: z.string(), cropId: z.string() }),
  seasonProperties: z.array(seasonTreePropertySchema)
});

export const seasonTreeResponseSchema = z.array(seasonTreeSchema);
